/**
 * API Client Configuration
 * 
 * This file configures the generated OpenAPI client with:
 * - Base URL from environment variables
 * - Auth0 token integration for authenticated requests
 */

import { OpenAPI } from './core/OpenAPI';

// Configure the base URL from environment variable or default
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:4000';

/**
 * Auth0 token getter function - will be set by AppContext
 */
let getAuth0Token: (() => Promise<string | null>) | null = null;

/**
 * Set the Auth0 token getter function
 * Called by AppContext to provide access to Auth0 tokens
 */
export function setApiAuth0TokenGetter(getter: () => Promise<string | null>): void {
  getAuth0Token = getter;
}

/**
 * Initialize the OpenAPI client configuration
 * This should be called once when the app starts
 */
export function initializeApiClient(): void {
  // Set the base URL (without /api/v1 since it's included in the generated paths)
  OpenAPI.BASE = API_BASE_URL;
  
  // Set up token resolver for authenticated requests
  OpenAPI.TOKEN = async () => {
    if (getAuth0Token) {
      try {
        const token = await getAuth0Token();
        return token || '';
      } catch (error) {
        console.error('Failed to get Auth0 token for API request:', error);
      }
    }
    
    // Fallback to localStorage for backward compatibility
    return localStorage.getItem('auth_token') || '';
  };
  
  // Disable credentials for development to avoid CORS issues with wildcard origin
  // Enable this when backend CORS is properly configured with specific origins
  OpenAPI.WITH_CREDENTIALS = false;
}

// Re-export everything from the generated client for convenience
export * from './index';

// Hand-maintained exports (not included in generated index.ts)
export { ApiError } from './core/ApiError';
export { getApiErrorMessage } from '../lib/api-error';

// Re-export AdviserResponseDto and PaginatedAdvisersResponseDto for AppContext
export type { AdviserResponseDto, PaginatedAdvisersResponseDto, FapSummaryDto } from './index';

